var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconCopyPaste({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#137ac9;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")), /*#__PURE__*/React.createElement("title", null, "copy-paste"), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.25,8.249v-3a1.5,1.5,0,0,0-1.5-1.5h-4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.25,3.749h-4a1.5,1.5,0,0,0-1.5,1.5v16.5a1.5,1.5,0,0,0,1.5,1.5h6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.421,4.736a.751.751,0,0,1-.712.513H7.291a.751.751,0,0,1-.712-.513l-1-3A.749.749,0,0,1,6.291.749h8.418a.749.749,0,0,1,.712.987Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 11.25,
    y: 11.249,
    width: 12,
    height: 12,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 14.25,
    y1: 14.249,
    x2: 20.25,
    y2: 14.249
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 14.25,
    y1: 17.249,
    x2: 20.25,
    y2: 17.249
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 14.25,
    y1: 20.249,
    x2: 16.5,
    y2: 20.249
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconCopyPaste);
export default __webpack_public_path__ + "static/media/streamline-icon-copy-paste.46e085e7.svg";
export { ForwardRef as ReactComponent };